import { Ergebnisse } from '../ws/ergebnis/ergebnisse.model';
import { AuspraegungGebaeude } from '../ws/dbKlassen/auspraegung-gebaeude.model';

export class TableTierplaetze {
  modul!: string;
  wert: (string | null)[] = [];
  information!: string;

  public static getTableTierlaetzeList(
    ergebnisse: Ergebnisse
  ): TableTierplaetze[] { 

    if (ergebnisse.ergebnisGebaeudeList.length == 0)
      return [];

    let tableTierplaetze: TableTierplaetze[] = [];

    let auspraegungGebaeudeList: AuspraegungGebaeude[] =
      ergebnisse.ergebnisGebaeudeList[0].gebaeude.tierplaetze;

    auspraegungGebaeudeList.forEach((entry) => {
      let element: TableTierplaetze = new TableTierplaetze();
      element.modul = entry.modul;
      element.information = entry.information
      ergebnisse.ergebnisGebaeudeList.slice(ergebnisse.ergebnisGebaeudeList.length === 1 ? 0 : 1).forEach((entry2) => {
        let found : boolean = false;
        entry2.gebaeude.tierplaetze.forEach((entry3) => {
 

          if (entry3.modul === element.modul) 
          {
            element.wert.push(entry3.wert.toString());
            found = true;
          }

        });

        if (!found)
          element.wert.push(null);
      });

      tableTierplaetze.push(element);
    });
  
    return tableTierplaetze;
  }
}
